

<div class="row no-gutters">
  <div class="col-sm-10">

    <!-- COMPACT MODE -->

    <div class="row no-gutters" *ngIf="compact">

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-label>{{ vehicle.trans.mileage | translate }}</mat-label>
            <input id="{{idPrefix}}compact.{{vehicle.trans.mileage}}"
                   type="number" matInput
                   [(ngModel)]="compactMileage"
                   (blur)="compactMileageUpdate()">
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-select id="{{idPrefix}}compact.unit"
                        [(ngModel)]="compactMileageUnit"
                        [disabled]="disabled">
              <mat-option *ngFor="let unitKey of objectKeys(mileageUnits)"
                          id="{{idPrefix}}compact.unit.{{unitKey}}"
                          [value]="mileageUnits[unitKey].code">
                {{ mileageUnits[unitKey].trans | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-select id="{{idPrefix}}compact.rse"
                        [(ngModel)]="compactMileageRse"
                        [disabled]="disabled">
              <mat-option *ngFor="let rseKey of objectKeys(mileageRSE)"
                          id="{{idPrefix}}compact.rse.{{rseKey}}"
                          [value]="mileageRSE[rseKey].key">
                {{ mileageRSE[rseKey].trans | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </div>


    <!-- DETAILED MODE -->

    <!-- READ -->
    <div class="row no-gutters"
         *ngIf="!compact">

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-label>{{ vehicle.trans.mileage | translate }}</mat-label>
            <input id="{{idPrefix}}read.{{vehicle.trans.mileage}}"
                   type="number" matInput
                   [(ngModel)]="vehicle.mileage_read"
                   (blur)="detailedMileageUpdate(mileageRSE.READ.key, (vehicle.mileage_read ? vehicle.mileage_read : null))">
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-select id="{{idPrefix}}read.unit"
                        [(ngModel)]="detailedReadUnitCode"
                        (ngModelChange)="detailedMileageUnitUpdate(mileageRSE.READ.key, vehicle.mileage_read_unit_code)"
                        [disabled]="disabled">
              <mat-option *ngFor="let unitKey of objectKeys(mileageUnits)"
                          id="{{idPrefix}}read.unit.{{unitKey}}"
                          [value]="mileageUnits[unitKey].code">
                {{ mileageUnits[unitKey].trans | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="row no-gutters">
          <span class="full-width dr-rse-padding">{{ mileageRSE.READ.trans | translate }}</span>
        </div>
      </div>

    </div>


    <!-- SPECIFIED -->

    <div class="row no-gutters"
         *ngIf="!compact">

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-label>{{ vehicle.trans.mileage | translate }}</mat-label>
            <input id="{{idPrefix}}specified.{{vehicle.trans.mileage}}"
                   type="number" matInput
                   [(ngModel)]="vehicle.mileage_specified"
                   (blur)="detailedMileageUpdate(mileageRSE.SPECIFIED.key, (vehicle.mileage_specified ? vehicle.mileage_specified : null))">
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-select id="{{idPrefix}}specified.unit"
                        [(ngModel)]="detailedSpecifiedUnitCode"
                        (ngModelChange)="detailedMileageUnitUpdate(mileageRSE.SPECIFIED.key, vehicle.mileage_specified_unit_code)"
                        [disabled]="disabled">
              <mat-option *ngFor="let unitKey of objectKeys(mileageUnits)"
                          id="{{idPrefix}}specified.unit.{{unitKey}}"
                          [value]="mileageUnits[unitKey].code">
                {{ mileageUnits[unitKey].trans | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="row no-gutters">
          <span class="full-width dr-rse-padding">{{ mileageRSE.SPECIFIED.trans | translate }}</span>
        </div>
      </div>

    </div>


    <!-- ESTIMATED -->

    <div class="row no-gutters"
         *ngIf="!compact">

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-label>{{ vehicle.trans.mileage | translate }}</mat-label>
            <input id="{{idPrefix}}estimated.{{vehicle.trans.mileage}}"
                   type="number" matInput
                   [(ngModel)]="vehicle.mileage_estimated"
                   (blur)="detailedMileageUpdate(mileageRSE.ESTIMATED.key, (vehicle.mileage_estimated ? vehicle.mileage_estimated : null))">
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4 dr-mileage-padding-right">
        <div class="row no-gutters">
          <mat-form-field class="full-width">
            <mat-select id="{{idPrefix}}estimated.unit"
                        [(ngModel)]="detailedEstimatedUnitCode"
                        (ngModelChange)="detailedMileageUnitUpdate(mileageRSE.ESTIMATED.key, vehicle.mileage_estimated_unit_code)"
                        [disabled]="disabled">
              <mat-option *ngFor="let unitKey of objectKeys(mileageUnits)"
                          id="{{idPrefix}}estimated.unit.{{unitKey}}"
                          [value]="mileageUnits[unitKey].code">
                {{ mileageUnits[unitKey].trans | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="row no-gutters">
          <span class="full-width dr-rse-padding">{{ mileageRSE.ESTIMATED.trans | translate }}</span>
        </div>
      </div>

    </div>
  </div>

  <div class="col-sm-2 align-self-center">
    <button mat-icon-button>
      <mat-icon id="{{idPrefix}}btn.detailed_mileage" class="dr-material-icon" *ngIf="compact" (click)="toDetailedMileage()" aria-label="detailed">add</mat-icon>
    </button>
  </div>
</div>
